
import { TimePickerProps, TimePickerState, TimePickerHandler } from "./timepicker";
import { TimePickerCSSStyleImpl } from "./timepickercss";
import * as React from "react";
import { TimePickerItem } from "./timepickeritem";
import { UIDataModel, UIComponentHandler } from '../uicomponent';
import { UIComponentViewImpl } from '../uicomponentview';

export class TimePickerView extends UIComponentViewImpl<UIDataModel>
{
    
    constructor(prop:any, handler:UIComponentHandler)
    {
        super(prop, handler);

    }
    bindHandlers()
    {
        this.onChange = this.onChange.bind(this);
    }
    
    draw(uiProps: TimePickerProps, uiState: TimePickerState, cssStyle: TimePickerCSSStyleImpl): JSX.Element 
    {
       super.draw(uiProps, uiState, cssStyle);

       return(
        <TimePickerItem  value={uiState.value} contentType={uiProps.inputType!==undefined ? uiProps.inputType:" "} hint={uiProps.placeholder}  onChange={this.onChange} label={uiProps.label} isRequired={uiProps.isRequired} style={cssStyle} disabled={uiProps.isDisabled===undefined?false:uiProps.isDisabled} errorMessage={uiState.errorMessage} autocomplete={uiProps.autocomplete!==undefined ? uiProps.autocomplete:"off"} onKeyPress={uiProps.onKeyPress}/>
       );
    }
    onChange(e : any): void {
        (this.getUIComponentHandler() as TimePickerHandler).onChange(e);
    }
    
    validate(): boolean
    {
        return true;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/timepicker/timepickerview.tsx